const screen = (state = "", action) => {
    switch (action.type){
        case 'TOGGLE_MODAL':
            return action.modal
        case 'TOGGLE_SETTINGS':
            return action.screen;
        case 'SWITCH_SCREEN':
            return action.screen;
        default:
            return state
    }
}

export default screen
